import * as R from 'ramda'
import { of } from 'rxjs'
import { delayWhen, distinctUntilChanged, filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { getP } from 'redux-polyglot'
import { queryFromString } from 'helpers/url'
import facebookPixel from 'tracking/facebookPixel'
import { isProductFetched } from 'domain/resources'
import * as Actions from 'store/actions/index.ts'
import { awaitForProductFetched } from 'store/epics/helpers'
import { isProductPageAction } from 'domain/router'
import {
  getCurrentProduct,
  getIsSaleFetched,
  getOperationCode,
  getOperationId,
  getProductCallPrice,
  getProductTitle,
  getSaleTitle
} from 'store/selectors'
import { disableFacebookTracking } from '../disable'

export const mapStateToFPEvent = (state) => {
  const product = getCurrentProduct(state)
  const p = getP(state)

  return {
    brand: getSaleTitle(state),
    content_ids: [product.key],
    content_name: getProductTitle(state),
    content_type: 'product',
    currency: p.t('common.money.code'),
    operation_code: getOperationCode(state),
    operation_ID: getOperationId(state),
    value: getProductCallPrice(state)
  }
}

const viewContentProductEpic = (actions$, state$) => actions$.pipe(
  disableFacebookTracking(actions$),
  ofType(LOCATION_CHANGE),
  distinctUntilChanged(R.eqBy(R.path(['payload', 'location', 'pathname']))),
  filter(isProductPageAction),
  delayWhen(locationChangeAction => {
    const resourceFetched$ = actions$.pipe(ofType(Actions.resources.RESOURCE_FETCHED))
    const locationChangeKey = queryFromString(locationChangeAction.payload.location.search).key
    return (getIsSaleFetched(state$.value) && isProductFetched(locationChangeKey)(state$.value))
      ? of({})
      : awaitForProductFetched(locationChangeKey, resourceFetched$, state$)
  }),
  tap(() => {
    facebookPixel.track('ViewContent', mapStateToFPEvent(state$.value))
  }),
  ignoreElements()
)

export default viewContentProductEpic
